import { Devices40 as o } from "./devices-40/index.js";
import { Extra48 as r } from "./extra-48/index.js";
import { Financial as m } from "./financial/index.js";
import { Hands as i } from "./hands/index.js";
import { Leisure as t } from "./leisure/index.js";
import { LocationsAndTransport as n } from "./locations-and-transport/index.js";
import { Products as p } from "./products/index.js";
import { UiAndPeople as f } from "./ui-and-people/index.js";
import { TechnologyAndHardware as s } from "./technology-and-hardware/index.js";
import { Various40 as d } from "./various-40/index.js";
import { AnimalsAndEmoticons as a } from "./animals-and-emoticons/index.js";
import { FoodAndDrink as e } from "./food-and-drinks/index.js";
const T = {
  Devices40: o,
  Extra48: r,
  Financial: m,
  Hands: i,
  Leisure: t,
  LocationsAndTransport: n,
  Products: p,
  UiAndPeople: f,
  TechnologyAndHardware: s,
  Various40: d,
  AnimalsAndEmoticons: a,
  FoodAndDrinks: e
};
export {
  T as Icons40
};
